module.exports = __webpack_public_path__ + "img/teaching_1.1aad434c.png";